import React, { useState } from "react";
import styled from "styled-components";
import FullButton from "../components/Buttons/FullButton";
import {
  Container,
  Form,
  FormWrapper,
  Input,
  Message,
  PageWrapper,
  StatusMessage,
  Wrapper,
} from "../style/view.styles";
import { PasswordInput } from "../components/Inputs/PasswordInput";
import GoogleSSOButton from "../components/Buttons/GoogleSSOButton";
import { useNavigate } from "react-router-dom";
import { makeApiRequest } from "../utils/RequestHandler";

export default function Register() {
  const [formStatus, setFormStatus] = useState({ message: "", type: "" });

  const [formData, setFormData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [role, setRole] = useState("talent");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleRoleChange = (selectedRole) => {
    setRole(selectedRole);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, password, confirmPassword } = formData;

    if (password !== confirmPassword) {
      setFormStatus({
        message: "Passwords do not match!",
        type: "error",
      });
      return;
    }

    setLoading(true);
    setFormStatus({
      message: "",
      type: "success",
    });

    try {
      const apiKey = process.env.REACT_APP_API_KEY;
      const appUrl = process.env.REACT_APP_API_URL;
      const response = await fetch(`${appUrl}/user/register`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          api_key: apiKey,
          username: email,
          password,
          confirm_password: confirmPassword,
          user_role: role,
        }),
      });

      const data = await response.json();

      if (data.success) {
        setFormStatus({
          message: "Registration successful! Check your email for OTP",
          type: "success",
        });
        setTimeout(() => {
          navigate("/verify-otp");
        }, 2000);
      } else {
        setFormStatus({
          message: data.result || "An error occurred. Please try again.",
          type: "error",
        });
      }
    } catch (error) {
      setFormStatus({
        message: "Something went wrong. Please try again later.",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleGoogleAuthSuccess = async (response) => {
    const { credential } = response;
    try {
      setLoading(true);
      const apiKey = process.env.REACT_APP_API_KEY;
      const response = await makeApiRequest("/google/sso/register/", "POST", {
        token: credential,
        user_role: role,
        api_key: apiKey,
      });
      if (response.success) {
        localStorage.setItem("user", JSON.stringify(response.result));
        navigate("/my-profile");
      } else {
        setFormStatus({
          message: response.result || "Registration failed",
          type: "error",
        });
      }
    } catch (error) {
      setFormStatus({
        message: error.message ?? "An error occurred during registration",
        type: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Wrapper className="paleBlueGreyBg">
        <Container>
          <PageWrapper className="container flexCenter">
            <FormWrapper>
              <h1 className="extraBold font40 darkGreenColor">Register As</h1>
              <RoleSelector style={{ paddingTop: "60px" }}>
                <RoleButton
                  active={role === "talent"}
                  onClick={() => handleRoleChange("talent")}
                >
                  Talent
                </RoleButton>
                <RoleButton
                  active={role === "organization"}
                  onClick={() => handleRoleChange("organization")}
                >
                  Organization
                </RoleButton>
              </RoleSelector>
              <Form onSubmit={handleSubmit}>
                <Input
                  type="email"
                  name="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
                <PasswordInput
                  type="password"
                  name="password"
                  placeholder="Password"
                  value={formData.password}
                  onChange={handleInputChange}
                  required
                />

                <PasswordInput
                  type="password"
                  name="confirmPassword"
                  placeholder="Confirm Password"
                  value={formData.confirmPassword}
                  onChange={handleInputChange}
                  required
                />
                <FullButton title={loading ? "Registering..." : "Register"} />
                <GoogleSSOButton
                  onSuccess={handleGoogleAuthSuccess}
                  authType="register"
                />
              </Form>
              {formStatus.message && (
                <StatusMessage type={formStatus.type}>
                  {formStatus.message}
                </StatusMessage>
              )}
              <Message className="font13">
                Already have an account? <a href="/login">Login here</a>
              </Message>
            </FormWrapper>
          </PageWrapper>
        </Container>
      </Wrapper>
    </>
  );
}

const RoleSelector = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-bottom: 20px;
`;

const RoleButton = styled.button`
  padding: 10px 20px;
  font-size: 1rem;
  border: 1px solid #bacad3;
  background-color: ${(props) => (props.active ? "#49cb86" : "#f8f9fa")};
  color: ${(props) => (props.active ? "#fff" : "#000")};
  border-radius: 5px;
  cursor: pointer;
  &:hover {
    background-color: ${(props) => (props.active ? "#3aa66a" : "#e8ecef")};
  }
`;
